import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxCheckBoxModule,
  DxDataGridModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorMessagePipe } from '../../../../_helpers/validacion-form.service';
import { ModalVerCondicionesComponent } from './modal-ver-condiciones.component';

@NgModule({
  declarations: [ModalVerCondicionesComponent],
  imports: [
    CommonModule,
    DxSwitchModule,
    DxTextBoxModule,
    MatDialogModule,
    ReactiveFormsModule,
    DxSelectBoxModule,
    ValidationErrorMessagePipe,
    DxTagBoxModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxLoadPanelModule,
  ],
})
export class ModalVerCondicionesModule {}
